import { COLORS } from "../../utils/js/constants";

export function loginStyle(theme) {
    return {
        formwrapper: {
            width: "100%",
        },
        bottomLogin: {
            backgroundColor: COLORS.primary,
            width: '50%',
        },
        avatarLogin: {
            width: 150,
            height: 150,
            marginBottom: 50
        },
        loginForm: {
            marginBottom: 50,
            width: "100%",
            height: 50,
            borderColor: 'orange',
            color: 'white !important',
        },
    }
}
